<script>
    export let context;
    const id = context.params.id;
    import Blogs from '../blogs_definitions';
    import NotFound from './NotFound.svelte';
    import './BlogPage.scss';
    import TwitterShare from '../components/TwitterShare.svelte';
    import FacebookShare from '../components/FacebookShare.svelte';
    const blog = Blogs.find(blog => blog.id === id);
    const error = blog === undefined;
</script>

{#if error}
    <NotFound/>
{:else}
    <section class="section blogpage container">
        <p class="title">{blog.title}</p>
        <p class="subtitle">
            <time>{blog.date}</time>
            <br/>
            By {blog.author}
        </p>
        <TwitterShare/>
        <FacebookShare/>
        <div class="content">
            <svelte:component this={blog.component}/>
        </div>
    </section>
{/if}